var _rect, _defs, _line, _line2, _line3, _line4, _line5, _line6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemgraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 28,
    fill: "#112240"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "memGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5195E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B19E5"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 32,
    x2: 34,
    y2: 72,
    stroke: "#E5195E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 32,
    x2: 94,
    y2: 72,
    stroke: "#E5195E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 72,
    x2: 94,
    y2: 72,
    stroke: "#8B19E5",
    strokeWidth: 3,
    strokeDasharray: "4,4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 72,
    x2: 64,
    y2: 100,
    stroke: "#8B19E5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 94,
    y1: 72,
    x2: 64,
    y2: 100,
    stroke: "#8B19E5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 32,
    x2: 64,
    y2: 100,
    stroke: "#64ffda",
    strokeWidth: 2.5,
    opacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 32,
    r: 14,
    fill: "url(#memGrad)",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 72,
    r: 12,
    fill: "url(#memGrad)",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 72,
    r: 12,
    fill: "url(#memGrad)",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 100,
    r: 11,
    fill: "url(#memGrad)",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 32,
    r: 5,
    fill: "#ffffff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 72,
    r: 4,
    fill: "#ffffff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 72,
    r: 4,
    fill: "#ffffff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 100,
    r: 3.5,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemgraph);
export default __webpack_public_path__ + "static/media/memgraph.e29f7e0c957a90fc3d2189a7cbec3b85.svg";
export { ForwardRef as ReactComponent };